/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tasks_filled': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 33',
    data: '<path pid="0" class="st0" d="M22 5.1h-2.4c-.1-1-.9-1.8-1.9-1.8h-1.4c-.5-1.5-2-2.5-3.6-2.5s-3.1 1-3.6 2.5H7.6c-1 0-1.8.8-1.9 1.8H3.4C2.1 5.1 1 6.1 1 7.5v22.7c0 1.3 1.1 2.4 2.4 2.4H22c1.3 0 2.4-1.1 2.4-2.4V7.5c0-1.4-1.1-2.4-2.4-2.4zm-15.2.1c0-.5.4-.9.9-.9h2.2l.1-.4c.3-1.3 1.5-2.2 2.8-2.2s2.5.9 2.8 2.2l.1.4h2.2c.5 0 .9.4.9.9v1.6c0 .5-.4.9-.9.9h-10c-.5 0-.9-.4-.9-.9V5.2zm16.6 25c0 .8-.6 1.4-1.4 1.4H3.4c-.8 0-1.4-.6-1.4-1.4V7.5c0-.8.6-1.4 1.4-1.4h2.4v1.2c0 .8.7 1.5 1.5 1.5h10.9c.8 0 1.5-.7 1.5-1.5V6.1H22c.8 0 1.4.6 1.4 1.4v22.7z"/><path pid="1" class="st0" d="M6.2 12.2c-.8 0-1.4.6-1.4 1.4 0 .8.6 1.4 1.4 1.4.8 0 1.4-.6 1.4-1.4 0-.7-.6-1.4-1.4-1.4zM6.2 24.3c-.8 0-1.4.6-1.4 1.4 0 .8.6 1.4 1.4 1.4.8 0 1.4-.6 1.4-1.4 0-.8-.6-1.4-1.4-1.4zM6.2 18.1c-.8 0-1.4.6-1.4 1.4 0 .8.6 1.4 1.4 1.4.8 0 1.4-.6 1.4-1.4 0-.8-.6-1.4-1.4-1.4zM10 13h11v1.1H10zM10 25.2h11v1.1H10zM10 18.8h11v1.1H10z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/tasks_filled.js